import React, { useEffect, useState } from 'react';
import { GridFilterInputValueProps } from '@mui/x-data-grid';

import SelectFilter, { SelectFilterOption } from './SelectFilter';
import getCertifications from '../../services/certifications';
import {
  ADMIN_RESPONSE_OPTIONS,
  CHECK_OUTCOME_OPTIONS,
  CHECK_TYPE_OPTIONS,
  SCREENING_STATE_OPTIONS,
  STATUS_OPTIONS,
} from './screeningLabels';

export function StatusFilter(props: GridFilterInputValueProps) {
  return <SelectFilter {...props} options={STATUS_OPTIONS} />;
}

export function ScreeningStateFilter(props: GridFilterInputValueProps) {
  return <SelectFilter {...props} options={SCREENING_STATE_OPTIONS} />;
}

export function CheckTypeFilter(props: GridFilterInputValueProps) {
  return <SelectFilter {...props} options={CHECK_TYPE_OPTIONS} />;
}

export function CheckOutcomeFilter(props: GridFilterInputValueProps) {
  return <SelectFilter {...props} options={CHECK_OUTCOME_OPTIONS} />;
}

export function AdminResponseFilter(props: GridFilterInputValueProps) {
  return <SelectFilter {...props} options={ADMIN_RESPONSE_OPTIONS} />;
}

// MUI DataGridPro remounts filter InputComponents each time the filter panel is opened
// or changed, so this is cached across mounts rather than refetched every time.
let certificationOptionsCache: Promise<SelectFilterOption[]> | null = null;

function loadCertificationOptions(): Promise<SelectFilterOption[]> {
  if (!certificationOptionsCache) {
    certificationOptionsCache = getCertifications().then(
      (certifications) => certifications.map((c) => ({ value: String(c.id), label: c.title })),
    );
  }
  return certificationOptionsCache;
}

export function CertificationFilter(props: GridFilterInputValueProps) {
  const [options, setOptions] = useState<SelectFilterOption[]>([]);

  useEffect(() => {
    loadCertificationOptions()
      .then(setOptions)
      .catch((err) => {
        certificationOptionsCache = null;
        console.error('Error fetching certification types', err);
      });
  }, []);

  return <SelectFilter {...props} options={options} />;
}
